import { Icon } from '@/components/icon';
import { Text } from '@/components/text';
import { tv } from '@/utils/styles';

const SMALL_SIZE = 'sm';
const MEDIUM_SIZE = 'md';

export interface StatusItemProps {
  children: string | React.ReactNode;
  icon?: string;
  isDisabled?: boolean;
  size?: typeof SMALL_SIZE | typeof MEDIUM_SIZE;
  className?: string;
}

const StatusItem = ({ icon, size = MEDIUM_SIZE, children, isDisabled = false, className }: StatusItemProps) => {
  const { base, text, dot, iconWrapper } = styles({ size, hasIcon: !!icon, isDisabled });

  return (
    <div className={base({ className })}>
      {icon && (
        <Icon
          name={icon}
          size={size === SMALL_SIZE ? 'base' : '20px'}
          color={!isDisabled ? 'text.secondary' : 'grey.300'}
          className={iconWrapper()}
        />
      )}
      <Text variant={size === SMALL_SIZE ? 'sm' : 'secondary'} className={text()}>
        {children}
      </Text>
      <span className={dot()} />
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex items-center',
    text: 'm-0 mr-6',
    dot: 'ml-auto block rounded-full bg-status-active',
    iconWrapper: 'mr-4',
  },
  variants: {
    size: {
      sm: {
        base: 'max-w-32',
        dot: 'size-[5px] min-w-0',
        iconWrapper: 'mr-3',
      },
      md: {
        base: 'max-w-48',
        dot: 'size-[7px] min-w-0',
        iconWrapper: 'mr-4',
      },
    },
    hasIcon: {
      true: {},
    },
    isDisabled: {
      true: {
        text: 'text-grey-350 line-through',
        dot: 'bg-grey-300',
      },
      false: {
        dot: 'bg-status-active',
      },
    },
  },
  compoundVariants: [
    {
      size: SMALL_SIZE,
      hasIcon: true,
      class: {
        base: '!max-w-40',
      },
    },
  ],
});

export { StatusItem };
